import script from "./NumbersSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumbersSection.vue?vue&type=script&setup=true&lang=ts"

import "./NumbersSection.vue?vue&type=style&index=0&id=84a73558&lang=scss"

const __exports__ = script;

export default __exports__